import { useEffect, useRef, useState, useCallback } from 'react';
import { MAX_INT32 } from '../utils';
import { noop } from 'lodash/fp';

// delay in milliseconds

export function useTimeout(callback: () => void, delay: number, tag: string) {
  const savedCallback = useRef<() => void>(noop);

  const [reset, set] = useState(false);

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    if (isNaN(delay) || delay === MAX_INT32) {
      return;
    }

    function tick() {
      savedCallback.current();
    }

    if (delay !== undefined || reset) {
      set(false);

      let id = setTimeout(tick, delay);

      console.log(`${tag} timer ${id} scheduled after ${delay}`);
      return () => {
        clearTimeout(id);
        console.log(`${tag} timer ${id} cleared`);
      };
    }
  }, [delay, reset, tag]);

  const resetTimeout = useCallback(() => {
    set(true);
  }, []);

  return { resetTimeout };
}
